import { createContext, useContext } from 'react';

import type { CompanySlug, MeCompany } from './me';

export interface ActiveCompanyValue {
  activeCompanyId: string | null;
  activeCompanyName: string | null;
  slug: CompanySlug | null;
  companies: MeCompany[];
  crossCompany: boolean;
  isLoading: boolean;
  isError: boolean;
}

export const ActiveCompanyContext = createContext<ActiveCompanyValue | null>(null);

export function useActiveCompany(): ActiveCompanyValue {
  const value = useContext(ActiveCompanyContext);
  if (!value) {
    throw new Error('useActiveCompany must be used within ActiveCompanyProvider');
  }
  return value;
}

/** Cambia la empresa activa. Solo acepta empresas del usuario; descarta los datos en
 *  caché de la anterior. Separado del valor de lectura (no todo consumidor escribe). */
export const SwitchActiveCompanyContext = createContext<((companyId: string) => void) | null>(null);

export function useSwitchActiveCompany(): (companyId: string) => void {
  const value = useContext(SwitchActiveCompanyContext);
  if (!value) {
    throw new Error('useSwitchActiveCompany must be used within ActiveCompanyProvider');
  }
  return value;
}
